<div class="review-section">
    <div class="review-section__sidebar">
        <ins-product-grade-hand-container
            class="review-section__hand"
            [reviewId]="reviewId"
        ></ins-product-grade-hand-container>
    </div>
    <div class="review-section__content review-section__content--mobile">
        <ins-reviews-container [reviewId]="reviewId" [itemsInView]="1"></ins-reviews-container>
    </div>
    <div class="review-section__content review-section__content--desktop">
        <ins-reviews-container [reviewId]="reviewId" [itemsInView]="3"></ins-reviews-container>
    </div>
    <div class="review-section__content">
        <div class="review-section__link text-center">
            <p>
                <a
                    [routerLink]="['/', productLink, 'reviews']"
                    class="link-secondary link-secondary--more"
                >
                    <svg class="svg-icon svg-icon--xs"><use href="assets/icons-ui.svg#rechts-open"></use></svg>
                    Alle beoordelingen
                </a>
            </p>
        </div>
    </div>
    <div class="review-section__footer">
        <ins-button-separator>
            <ins-mening-button [reviewId]="reviewId"></ins-mening-button>
        </ins-button-separator>
    </div>
</div>
